import $ from 'jquery';
/* expose jQuery for modules */
window.$ = $;
window.jQuery = $;

import './main_menu';
import './theme';
import gtServicesSlider from './sliders/gtServices-slider';
import subCategoriesSlider from './sliders/subCategories-slider';
import servicesBoxSlider from './sliders/servicesBox-slider';
import headerSlider from './sliders/header-slider';
import {usefulBox} from './theme';
import {faqBox} from './theme';
import megaMenu from './mega-menu';
import stores from "./map";

$(document).ready(() => {

    const _gtServicesSlider = new gtServicesSlider();
    _gtServicesSlider.init();
    const _subCategoriesSlider = new subCategoriesSlider();
    _subCategoriesSlider.init();
    const _servicesBoxSlider = new servicesBoxSlider();
    _servicesBoxSlider.init();
    const _headerSlider = new headerSlider();
    _headerSlider.init();

    usefulBox();
    faqBox();
    megaMenu();


});


    


